'use client';

import cn from 'classnames';
import { useContext, useEffect, useState } from 'react';

import Topbar from '@/components/Topbar';
import { useProductGallery } from '@/contexts/GalleryModalContext';
import ScreenWidthContext from '@/contexts/ScreenWidthContext';

import styles from './styles.module.scss';

type Props = {
  onlyLogo?: boolean;
};

const TopbarWrapper = (props: Props) => {
  const { onlyLogo } = props;
  const { isMobile } = useContext(ScreenWidthContext);
  const [isScrolled, setIsScrolled] = useState(false);
  const { isGalleryOpen } = useProductGallery();

  const handleScroll = () => {
    const scrolled = window.scrollY > 175;
    setIsScrolled(scrolled);
  };

  useEffect(() => {
    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  return (
    <>
      <Topbar
        className={cn(styles.topBar, {
          [styles.onlyLogoFixed]: onlyLogo,
        })}
        dropdownClass={styles.dropdownContainer}
        isVisible
        onlyLogo={onlyLogo}
        isMobile={isMobile}
      />
      {!isMobile && !onlyLogo && (
        <Topbar
          className={cn(styles.topBarFixed, {
            [styles.show]: isScrolled && !isMobile && !isGalleryOpen,
          })}
          dropdownClass={cn(styles.dropdownContainer, {
            [styles.moved]: isScrolled && !isMobile,
          })}
          isCentered
          isSmallerLogo
          isMobile={isMobile}
        />
      )}
    </>
  );
};

export default TopbarWrapper;
